import React from 'react'
import { StepsContainer, StepItem, StepsContainerV1 } from '../../user/styled';
import { useTranslation } from 'react-i18next';
import { theme } from '../../../theme/theme';
import { useSwitchDesign } from '../../../hooks/useSwitchDesign';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material';

const Stepper = ({
  steps,
  activeGroup,
  onClick,
  version = '1'
}) => {
  const { t } = useTranslation()
  const { isNewDesign } = useSwitchDesign()

  // Customize colors for the stepper
  const { third } = theme
  let activeColor, inactiveColor
  activeColor = isNewDesign ? third : "#006d72"
  inactiveColor = isNewDesign ? 'rgba(255, 255, 255, 0.2)' : '#767676'
  const responsiveTheme = useTheme();
  const isMobile = useMediaQuery(responsiveTheme.breakpoints.down('sm'));


  return (
    <>
      {/* New Version Stepper */}
      {
        (version === '2') && steps && steps.length > 1 && (
          <StepsContainer style={{ ['--active-color']: activeColor, ['--inactive-color']: inactiveColor }}>
            {steps.map((step, index) => {
              const done = (step+1) <= activeGroup || (activeGroup === 1 && step === 1);
              const defaultNames = [
                t('stepper.basic'),
                t('stepper.personalInfo'),
                t('stepper.personalRef'),
                t('stepper.financial'),
                t('stepper.confirm'),
                t('stepper.final')
              ];
              const label = (defaultNames[index] || `${t('stepper.step')} ${index + 1}`);

              return (
                <StepItem
                  onClick={() => onClick(index)}
                  key={index}
                  className={`step-item ${(done && activeGroup !==1) ? 'done' : ''}`}
                  role="button"
                  tabIndex={0}
                  onKeyPress={() => onClick(index)}
                  aria-label={`Go to step ${index + 1}`}
                >
                  <div
                    className="step-circle"
                    style={{ borderColor: done ? activeColor : inactiveColor }}
                  />
                  <div className="step-label" title={label}>
                    {!isMobile ? label : `${t('stepper.step')} ${index+1}`}
                  </div>
                </StepItem>
              );
            })}
          </StepsContainer>
        )
      }
      {/* Old Stepper */}
      {
        (version === '1') && (
          <StepsContainerV1>
              {steps.map((step, index) =>
                <div 
                  onClick={() => {
                    let stepToGo = index
                    onClick(stepToGo)
                  }}
                  key={ index } 
                  style={{
                    height: 5,
                    width: `${100 / steps.length}%`,
                    margin: 5,
                    borderTop: `10px solid ${
                      step <= activeGroup ? activeColor : "#767676"}`,
                    cursor: 'pointer',
                    borderRadius: '4px'
                  }} 
                />
              )}
            </StepsContainerV1>
        )
      }
    </>
  )
}

export default Stepper